import React, { useEffect, useState } from 'react';
import { AppAdapter } from '../../../../../infraestructure/persistence/rest/AppAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { StateAppView } from './index';

export const StateApp = (props:any) => {

	const api = new AppAdapter();
	const { exceptionError, resultError, launchNotification } = useNotifications();
	let result: any;

	const getStateApp = async () => {
		try {
			result = await api.GetEstado();
			if(result.data!==undefined && result.data!==''){
				return result.data.bloqueado;
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
    };

  return <StateAppView getData={getStateApp} {...props}/>
};

export default StateApp;